import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { memo, useMemo } from "react";
import { PLAYBACK_SPEEDS } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/constants/playbackSpeed";
import { SelectedOptionIcon } from "~/components/AssetModal/Visualizer/VideoVisualizer/VideoVisualizerInner/shared/SelectedOptionIcon";
import { DropdownMenuWithActionSheet } from "~/components/Menus/DropdownMenuWithActionSheet";
export const PlaybackSpeedOptions = /*#__PURE__*/ memo((param)=>{
    let { currentPlaybackSpeed, onSelectPlaybackSpeed, container } = param;
    const options = useMemo(()=>{
        const optionsArray = [
            {
                id: "speed",
                label: "Speed",
                type: "title"
            }
        ];
        PLAYBACK_SPEEDS.map((speed)=>{
            optionsArray.push({
                id: "playback-speed-".concat(speed),
                label: "".concat(speed, "x"),
                onSelect: ()=>onSelectPlaybackSpeed(speed),
                suffix: speed === currentPlaybackSpeed ? /*#__PURE__*/ _jsx(SelectedOptionIcon, {}) : null,
                type: "item"
            });
        });
        return optionsArray;
    }, [
        currentPlaybackSpeed,
        onSelectPlaybackSpeed
    ]);
    return /*#__PURE__*/ _jsx(DropdownMenuWithActionSheet, {
        "data-theme": "dark",
        options: options,
        container: container,
        trigger: /*#__PURE__*/ _jsxs(Button, {
            appearance: "ghost",
            color: currentPlaybackSpeed === 1 ? "grey" : "blue",
            size: "large",
            children: [
                currentPlaybackSpeed,
                "x"
            ]
        }),
        title: "Playback speed"
    });
});
PlaybackSpeedOptions.displayName = "PlaybackSpeedOptions";
